(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arca-event-checkin"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initializeAll() {
      var roots = document.querySelectorAll('[data-event-checkin]');

      Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.eventCheckinReady === 'true') return;
      root.dataset.eventCheckinReady = 'true';

      var form = root.querySelector('[data-checkin-form]');
      if (!form) return;

      var loading = root.querySelector('[data-loading]');
      var success = root.querySelector('[data-success]');
      var submitButton = root.querySelector('[data-submit]');
      var formError = root.querySelector('[data-form-error]');
      var inlineError = root.querySelector('[data-error="0"]');
      var submitting = false;

      function getField(name) {
        return root.querySelector('[data-field="' + name + '"]');
      }

      function setFormError(message) {
        if (!formError) return;

        formError.textContent = message || '';
        formError.hidden = !message;
      }

      function setInlineError(message) {
        if (!inlineError) return;

        inlineError.textContent = message || '';
        inlineError.hidden = !message;
      }

      function isValidEmail(value) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }

      function setFieldInvalid(field, isInvalid) {
        if (!field) return;

        if (isInvalid) field.setAttribute('aria-invalid', 'true');
        else field.removeAttribute('aria-invalid');
      }

      function validateForm() {
        var fullNameField = getField('fullName');
        var emailField = getField('email');
        var phoneField = getField('phone');
        var fullName = fullNameField ? fullNameField.value.trim() : '';
        var email = emailField ? emailField.value.trim() : '';
        var phone = phoneField ? phoneField.value.trim() : '';
        var errors = [];
        var firstInvalid = null;

        setFieldInvalid(fullNameField, !fullName);
        setFieldInvalid(emailField, !email || !isValidEmail(email));
        setFieldInvalid(phoneField, !phone);

        if (!fullName) {
          errors.push('Please enter your full name.');
          firstInvalid = fullNameField;
        }

        if (!email) {
          errors.push('Please enter your email.');
          if (!firstInvalid) firstInvalid = emailField;
        } else if (!isValidEmail(email)) {
          errors.push('Please enter a valid email.');
          if (!firstInvalid) firstInvalid = emailField;
        }

        if (!phone) {
          errors.push('Please enter your phone number.');
          if (!firstInvalid) firstInvalid = phoneField;
        }

        setInlineError(errors.join(' '));

        if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus();

        return errors.length === 0;
      }

      function normalizePhone(value) {
        var phone = (value || '').trim().replace(/[^\d+]/g, '');

        if (!phone) return '';

        if (phone.indexOf('00') === 0) return '+' + phone.slice(2);
        if (phone.indexOf('+') === 0) return phone;
        if (phone.indexOf('0') === 0) return '+84' + phone.slice(1);
        if (phone.indexOf('84') === 0) return '+' + phone;

        return phone;
      }

      function splitName(fullName) {
        var parts = fullName.trim().split(/\s+/).filter(Boolean);

        return {
          firstName: parts.shift() || fullName.trim(),
          lastName: parts.join(' '),
        };
      }

      function buildPayload() {
        var fullName = getField('fullName').value.trim();
        var name = splitName(fullName);
        var email = getField('email').value.trim();
        var phone = normalizePhone(getField('phone').value);
        var instagram = getField('instagram').value.trim();
        var sourceName = root.dataset.sourceEvent || "ARCA Let's Connect";
        var properties = {
          'Full Name': fullName,
          Instagram: instagram,
          'Signup Page URL': window.location.href,
          consent: true,
        };
        var profileAttributes = {
          first_name: name.firstName,
          properties: properties,
          subscriptions: {
            email: {
              marketing: {
                consent: 'SUBSCRIBED',
              },
            },
          },
        };

        if (name.lastName) profileAttributes.last_name = name.lastName;
        if (phone) profileAttributes.phone_number = phone;
        profileAttributes.email = email;

        var klaviyoPayload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: sourceName,
              profile: {
                data: {
                  type: 'profile',
                  attributes: profileAttributes,
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: (root.dataset.klaviyoListId || '').trim(),
                },
              },
            },
          },
        };

        return {
          klaviyo: klaviyoPayload,
          submitted_at: new Date().toISOString(),
          full_name: fullName,
          instagram: instagram,
          email: email,
          phone: phone,
          signup_page_url: window.location.href,
          consent: true,
        };
      }

      function setLoading(isLoading) {
        submitting = isLoading;
        if (loading) loading.hidden = !isLoading;
        if (submitButton) submitButton.disabled = isLoading;
      }

      function subscribeToKlaviyo(payload) {
        var publicKey = (root.dataset.klaviyoPublicKey || '').trim();
        var listId = (root.dataset.klaviyoListId || '').trim();

        if (!publicKey || !listId) {
          return Promise.reject(new Error('Klaviyo configuration is missing.'));
        }

        return fetch(
          'https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(publicKey),
          {
            method: 'POST',
            headers: {
              Accept: 'application/vnd.api+json',
              'Content-Type': 'application/vnd.api+json',
              Revision: '2026-07-15',
            },
            body: JSON.stringify(payload),
          }
        ).then(function (response) {
          if (response.ok) return response;

          return response.text().then(function (detail) {
            var error = new Error('Klaviyo subscription failed.');
            error.detail = detail;
            throw error;
          });
        });
      }

      function sendToGoogleSheet(payload) {
        var webhookUrl = (root.dataset.googleSheetWebhookUrl || '').trim();

        if (!webhookUrl) return Promise.reject(new Error('Google Sheet webhook configuration is missing.'));

        return fetch(webhookUrl + '?payload=' + encodeURIComponent(JSON.stringify(payload)), {
          method: 'GET',
          mode: 'no-cors',
        });
      }

      function finish() {
        setLoading(false);
        form.hidden = true;
        if (success) success.hidden = false;
        root.classList.add('is-complete');

        var countdown = success ? success.querySelector('[data-redirect-countdown]') : null;
        if (countdown) {
          var secondsRemaining = 6;
          var countdownTimer = window.setInterval(function () {
            secondsRemaining -= 1;
            countdown.textContent = String(secondsRemaining);

            if (secondsRemaining <= 0) {
              window.clearInterval(countdownTimer);
              window.setTimeout(function () {
                window.location.assign(root.dataset.homeUrl || '/');
              }, 350);
            }
          }, 1000);
        }

        if (success) {
          window.setTimeout(function () {
            try {
              success.focus({ preventScroll: true });
            } catch (error) {
              success.focus();
            }
          }, 0);
        }
      }

      [getField('fullName'), getField('email'), getField('phone'), getField('instagram')].forEach(function (field) {
        if (!field) return;

        field.addEventListener('input', function () {
          setFieldInvalid(field, false);
          setInlineError('');
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (submitting || !validateForm()) return;

        setFormError('');

        var honeypotField = root.querySelector('[data-honeypot]');
        var honeypot = honeypotField ? honeypotField.value.trim() : '';
        if (honeypot) {
          finish();
          return;
        }

        setLoading(true);

        var payload = buildPayload();

        subscribeToKlaviyo(payload.klaviyo)
          .then(function () {
            return sendToGoogleSheet(payload);
          })
          .then(function () {
            finish();
          })
          .catch(function (error) {
            console.error('ARCA event check-in failed:', error);
            setLoading(false);
            setFormError('We could not submit your details. Please try again.');
          });
      });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', initializeAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["for-business-enquiry"] && !Shopify.designMode) return;
  try {
    
  const openModal = (modal) => {
    if (!modal) return;
    const closeButtons = modal.querySelectorAll('[data-success-modal-close]');
    let closeTimer;

    const closeModal = () => {
      if (modal.open) {
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      }
      if (closeTimer) window.clearTimeout(closeTimer);
    };

    closeButtons.forEach((btn) => btn.addEventListener('click', closeModal));
    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.matches('[data-success-modal-close]')) {
        closeModal();
      }
    });
    modal.addEventListener('close', () => {
      if (closeTimer) window.clearTimeout(closeTimer);
    }, { once: true });

    if (typeof modal.showModal === 'function') {
      try {
        modal.showModal();
      } catch (e) {
        modal.setAttribute('open', '');
      }
    } else {
      modal.setAttribute('open', '');
    }

    const firstAction = modal.querySelector('.for-business-enquiry__success-confirm-btn') || modal.querySelector('[data-success-modal-close]');
    firstAction?.focus();
    closeTimer = window.setTimeout(closeModal, 9000);
  };

  const initSuccessModal = () => {
    document.querySelectorAll('.for-business-enquiry [data-success-modal]').forEach((modal) => {
      if (modal.dataset.initialized === 'true') return;
      modal.dataset.initialized = 'true';

      const hasPostedParam = new URLSearchParams(window.location.search).has('contact_posted');
      const isLiquidPosted = modal.dataset.liquidPosted === 'true';

      if (hasPostedParam || isLiquidPosted) {
        openModal(modal);

        if (hasPostedParam) {
          const currentUrl = new URL(window.location.href);
          currentUrl.searchParams.delete('contact_posted');
          window.history.replaceState(window.history.state, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
        }
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSuccessModal);
  } else {
    initSuccessModal();
  }
  document.addEventListener('shopify:section:load', initSuccessModal);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.for-business-enquiry__form')) return;

    event.preventDefault();

    if (form.dataset.submitting === 'true') return;

    const button = form.querySelector('.for-business-enquiry__submit');
    const submitting = form.querySelector('.for-business-enquiry__submitting');
    const section = form.closest('.for-business-enquiry') || document;
    const modal = section.querySelector('[data-success-modal]');
    const errorBox = form.querySelector('.for-business-enquiry__message--error');

    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    if (submitting) submitting.hidden = false;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      const formData = new FormData(form);
      const action = form.getAttribute('action') || '/contact';

      const response = await fetch(action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      // If Shopify redirects to captcha challenge
      if (response.url && response.url.includes('/challenge')) {
        window.location.href = response.url;
        return;
      }

      const responseText = await response.text();
      if (responseText.includes('challenge-form') || responseText.includes('/challenge')) {
        form.submit();
        return;
      }

      // Check if response contains Shopify form errors
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseText, 'text/html');
      const docErrors = doc.querySelector('.for-business-enquiry__message--error, .errors, [role="alert"]');

      if (docErrors && docErrors.textContent.trim().length > 0 && !responseText.includes('contact_posted=true')) {
        if (errorBox) {
          errorBox.innerHTML = docErrors.innerHTML;
          errorBox.hidden = false;
        }
        form.dataset.submitting = 'false';
        form.removeAttribute('aria-busy');
        if (submitting) submitting.hidden = true;
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
        return;
      }

      // Successful submission
      form.reset();
      form.dataset.submitting = 'false';
      form.removeAttribute('aria-busy');
      if (submitting) submitting.hidden = true;
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }

      openModal(modal);
    } catch (err) {
      console.warn('Enquiry form submission fallback:', err);
      form.dataset.submitting = 'false';
      form.submit();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const initializeProductListDots = (root) => {
        if (root.dataset.productListDotsReady === 'true') return;

        const slideshow = root.querySelector('.resource-list.resource-list__carousel > div > slideshow-component');
        const dots = [...root.querySelectorAll('[data-product-list-dot]')];

        if (!slideshow || dots.length === 0) return;

        const mobileQuery = window.matchMedia('(max-width: 749px)');
        const updateActiveDot = (slideIndex) => {
          const isMobile = mobileQuery.matches;

          root.querySelectorAll('.product-list__carousel-dots').forEach((dotList) => {
            dotList.hidden = dotList.classList.contains('product-list__carousel-dots--mobile') !== isMobile;
          });

          dots.forEach((dot) => {
            const dotIndex = Number(dot.dataset.slideIndex || 0);
            const isVisible = dot.closest('.product-list__carousel-dots--mobile') ? isMobile : !isMobile;
            dot.setAttribute('aria-selected', String(isVisible && dotIndex === slideIndex));
          });
        };

        dots.forEach((dot) => {
          dot.addEventListener('click', (event) => {
            event.preventDefault();
            slideshow.select(Number(dot.dataset.slideIndex || 0), event);
          });
        });

        slideshow.addEventListener('slideshow:select', (event) => {
          updateActiveDot(event.detail.index);
        });

        mobileQuery.addEventListener('change', () => updateActiveDot(slideshow.current || 0));
        root.dataset.productListDotsReady = 'true';
        updateActiveDot(0);
      };

      const initialize = () => {
        document.querySelectorAll('[data-testid="product-list"]').forEach(initializeProductListDots);
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true });
      } else {
        initialize();
      }
    })();
  
  } catch(e) { console.error(e); }
})();
})();
